export const schema = () => {
  return {
    type: "object",
    required: [],
    properties: {
      contact_number: {
        type: "string",
        title: "Contact Number",
        pattern: "^\\+?[\\d\\s\\-()]+$",
      },
      department: {
        type: "string",
        title: "Department",
        enum: [
          "Digital",
          "Education",
          "Engineering",
          "Arts",
          "Accountancy",
          "Technology",
        ],
        enumNames: [
          "College of Computing, Multimedia Arts and Digital Innovation",
          "College of Education",
          "College of Engineering",
          "College of Arts and Sciences",
          "College of Business and Accountancy",
          "College of Technology",
        ],
      },
      program: {
        type: "string",
        title: "Program",
        enum: ["BSIT", "BSCS", "BSED", "BEED", "BSBA", "BSA", "BSCE"],
        enumNames: [
          "Bachelor of Science in Information Technology",
          "Bachelor of Science in Computer Science",
          "Bachelor of Secondary Education",
          "Bachelor of Elementary Education",
          "Bachelor of Science in Business Administration",
          "Bachelor of Science in Accountancy",
          "Bachelor of Science in Civil Engineering",
        ],
      },
      year: {
        type: "string",
        title: "Year",
        enum: [
          "1st Year",
          "2nd Year",
          "3rd Year",
          "4th Year",
          "5th Year",
          "Graduate",
        ],
        enumNames: [
          "1st Year",
          "2nd Year",
          "3rd Year",
          "4th Year",
          "5th Year",
          "Graduate",
        ],
      },
      semester: {
        type: "string",
        title: "Semester",
        enum: ["1st Semester", "2nd Semester", "Summer"],
        enumNames: ["1st Semester", "2nd Semester", "Summer"],
      },
    },
  };
};

export default schema;
